import {TAGS} from '@/constant/coursePlan';
import i18n from '@/i18n/index.js';
import {CURRENCY_MARKET_MAPPING} from '@/constant/market';
import {CURRENCY_MAPPING} from '@/constant/language';
import {CURRENCY} from '@/constant/currency';


export default {
  computed: {
    userData() {
      return this.$store.getters['user/userData'];
    },
    hasBuyVip() {
      return !!this.userData.liveCourseEndAt;
    },
  },
  methods: {
    isSamePage(name) {
      return this.$route.name === name;
    },
    goPage(name, {query, params} = {}) {
      if (this.isSamePage(name)) return;
      this.$router.push({name, query, params});
    },
    goVIP() {
      if (this.hasBuyVip) {
        return this.goPage('vip-benefits');
      }
      return this.goPage('vip-training-plan');
    },
    goSetting(tab) {
      if (tab) {
        if (this.isSamePage(name)) {
          if (this.$route.query.tab === tab) {
            return;
          } else {
            return this.$router.replace({query: {tab}});
          }
        } else {
          return this.$router.push({name: 'setting', query: {tab}});
        }
      }
      this.goPage('setting');
    },
    goNpcList(npc) {
      this.goPage('npc-list', {query: {npcId: npc.id, series: npc.series}});
    },
    goRankTest() {
      this.goPage('rank-test');
    },
    goNotification() {
      this.goPage('notification');
    },
    goPersonal() {
      this.goPage('personal');
    },
    goLadder() {
      this.goPage('ladder');
    },
    goKgp() {
      const kgpCount = this.$store.getters['course/kgpCount'];
      if (kgpCount === 0) {
        this.$Message.error(this.$t('沒有幼兒園教學課程'));
        return;
      }
      if (kgpCount === 1) {
        const plans = this.$store.state.course.plans;
        const plan = plans.find((plan) => plan?.tags?.includes(TAGS.KGP));
        return this.$router.push({
          name: 'kgp-contents',
          params: {
            id: plan.id,
          },
        });
      }

      this.$router.push({
        name: 'kgp-list',
      });
    },
    goTgc() {
      const tgcCount = this.$store.getters['course/tgcCount'];
      if (tgcCount === 0) {
        this.$Message.error(this.$t('沒有圍棋學院課程'));
        return;
      }
      if (tgcCount === 1) {
        const plans = this.$store.state.course.plans;
        const plan = plans.find((plan) => plan?.tags?.includes(TAGS.TGC));
        return this.$router.push({
          name: 'tgc-contents',
          params: {
            id: plan.id,
          },
        });
      }
      this.$router.push({
        name: 'tgc-list',
      });
    },
    goStudentPvpManagement() {
      this.$router.push({name: 'studentPvpManagement'});
    },
    goTournament(size = 9) {
      this.$router.push({
        name: 'tournament',
        query: {
          tournamentType: `tournament_${size}`,
        },
      });
    },
    goCameraToScoreGame(size) {
      this.$router.push({
        name: 'cameraToScoreGame',
        query: {size},
      });
    },
    goMyCourse() {
      this.$router.push({
        name: 'myCourses',
      });
    },
    goMyStudyTask() {
      this.$router.push({
        name: 'learningStudyTasks',
      });
    },
    goLearningCourse({aiCourseId, day, courseUniqueKey, videoId} = {}) {
      this.$router.push({
        name: 'learningPage',
        params: {
          mode: 'course',
        },
        query: {
          aiCourseId,
          day,
          courseUniqueKey,
          videoId,
        },
      });
    },
    goPvp() {
      this.$store.commit('env/setIsSelectPvpActionModalShow', true);
    },
    goVideo({aiCourseId, courseUniqueKey, videoId}) {
      this.$router.push({
        name: 'courseVideo',
        params: {courseUniqueKey},
        query: {
          aiCourseId,
          videoId,
        },
      });
    },
    goMoreCourse() {
      this.$router.push({name: 'more-about-courses'});
    },
    goStudentManagement() {
      this.$router.push({name: 'studentManagement'});
    },
    goBrickAndMortarStore() {
      this.$openHomePage('/origin/#/brick-and-mortar-store');
    },
    goVerificationList() {
      this.$store.commit('env/setHasVerificationNotification', false);
      this.$router.push({name: 'verificationList'});
    },
    gotoProductPage(salePage) {
      this.$firebase.selectContent('course', salePage.name);
      const {marketSalePageId, coursePlanId, verificationProductId} = salePage;
      if (marketSalePageId) {
        this.$router.push({name: 'productPage', params: {marketSalePageId}});
      } else if (coursePlanId) {
        const locale = i18n.locale;
        const currency = CURRENCY_MAPPING[locale] || CURRENCY.USD;
        const marketId =
          CURRENCY_MARKET_MAPPING[currency] ||
          CURRENCY_MARKET_MAPPING[CURRENCY.USD];
        const marketSalePageId = `${marketId}-${locale}-${coursePlanId}`;
        this.$router.push({name: 'productPage', params: {marketSalePageId}});
      } else if (verificationProductId) {
        const locale = i18n.locale;
        const currency = CURRENCY_MAPPING[locale] || CURRENCY.USD;
        const marketId =
          CURRENCY_MARKET_MAPPING[currency] ||
          CURRENCY_MARKET_MAPPING[CURRENCY.USD];
        const marketSalePageId = `${marketId}-${locale}-verification`;
        this.$router.push({name: 'productPage', params: {marketSalePageId}, query: {productId: verificationProductId}});
      }
    },
    nextAction() {
      this.$alert(this.$t('新功能快準備好了，再稍等我們一下下哦！'));
    },
  },
};
